import React from 'react'

import Page from '../components/Page';

const NotFoundPage = () => {
  return <Page>Oops! Something went wrong</Page>
}

export default NotFoundPage
